<template>
  <div id="login">
    <div class="bacCon">
      <div class="content">
        <div class="title">代理注册</div>
        <div class="item">
          <div class="left">
            <span style="color: #FF0000;">*</span>用户名：
          </div>
          <input class="inputBac" v-model="account" />
          <div class="inputSub">{{accountP}}</div>
        </div>

        <div class="item">
          <div class="left">
            <span style="color: #FF0000;">*</span>密码：
          </div>
          <input class="inputBac" v-model="pwd" />
          <div class="inputSub">6-15位小写字母或数字</div>
        </div>

        <div class="item">
          <div class="left">
            <span style="color: #FF0000;">*</span>确认密码：
          </div>
          <input class="inputBac" v-model="confirmPwd" />
          <div class="inputSub">必须与登录密码一致</div>
        </div>
        <div class="item">
          <div class="left">
            <span style="color: #FF0000;">*</span>姓名：
          </div>
          <input class="inputBac" v-model="userName" />
          <div class="inputSub">请输入正确的姓名</div>
        </div>
        <div class="item">
          <div class="left">
            <span style="color: #FF0000;">*</span>联系电话：
          </div>
          <input class="inputBac" v-model="phone"  maxlength="11"/>
          <div class="inputSub">请输入正确的联系电话</div>
        </div>
        <div class="item">
          <div class="left">QQ号：</div>
          <input class="inputBac" v-model="qqNum" />
          <div class="inputSub">请输入正确的QQ号</div>
        </div>

        <div class="r-bottom1">
          <input type="checkbox" class="radio" v-model="selectCheck2" value="selectCheck2" />
          <div>
            我已阅读并同意
            <span style="color: #1b66c7;">《用户服务协议》</span>
          </div>
        </div>

        <div class="bottom" style="margin-bottom: 15px;margin-top: 10px;">
          <button class="btn" background-color="#ff000" @click="ensure()">立即注册</button>
        </div>
        <div
          style="margin-top: 1px;margin-left:110px;margin-bottom: 10px;color: #333333;font-size: 12px;"
        >
          温馨提示：带
          <span style="color: #FF0000;">*</span>为必填项，其他为选填
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../login/login.scss";
export default {
  data() {
    return {
      account: "",
      pwd: "",
      confirmPwd: "",
      userName: "",
      phone: "",
      qqNum: "",
      selectCheck2: false,
      accountP: ""
    };
  },
  mounted() {
    this.reset();
    if (window.mergeAccount) {
      this.accountP = "必须是4-13位字母和数字组合";
    } else {
      this.accountP = "必须是4-15位字母和数字组合";
    }
  },
  methods: {
    checkAccount() {
      var res = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
      if (window.mergeAccount) {
        if (
          this.account.length >= 4 &&
          this.account.length <= 13 &&
          res.test(this.account)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          this.account.length >= 4 &&
          this.account.length <= 15 &&
          res.test(this.account)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkPwd() {
      return /^[a-zA-Z0-9]{6,15}$/.test(this.pwd);
    },
    checkPhone() {
      return /^1[3456789]\d{9}$/.test(this.phone);
    },
    toCDB(str) {
      //全角转为半角
      var tmp = "";
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i));
        }
      }
      return tmp;
    },
    reset() {
      this.pwd = "";
      this.confirmPwd = "";
      this.phone = "";
      this.account = "";
      this.userName = "";
      this.qqNum = "";
      this.accountType = 0;
      this.pwdType = 0;
      this.confirmPwdType = 0;
      this.selectCheck2 = false;
    },
    ensure() {
      if (this.checkAccount() == false) {
        this.$message("请输入正确账号");
        return;
      }
      if (this.checkPwd() == false) {
        this.$message("请输入符合规则的密码");
        return;
      }
      if (this.confirmPwd != this.pwd) {
        this.$message("确认密码和密码不一致");
        return;
      }
      if (this.checkPhone() == false) {
        this.$message("请输入正确的手机号");
        return;
      }
      if (this.selectCheck2 == false) {
        this.$message("请同意用户服务协议");
        return;
      }
      var _this = this;
      var data = {
        phone: _this.phone,
        name: _this.account,
        password: _this.pwd,
        nickname: this.userName, //姓名
        qq: this.qqNum,
        wechat: ""
      };
      //账号处理
      if (window.mergeAccount) {
        data.name = this.account + window.mergeAccount;
      }
      this.$set(data, "clientItem", window.childCode);
      this.$set(data, "appId", window.theme);
      this.$http.post(this.$api.appSave, data).then(res => {
        if (res.code == 0) {
          this.$message("注册成功");
          this.reset();
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style>
.bacCon {
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}
</style>